<template>
  <div class="cir-progress" :id="baseContainer">
    <div class="value-container" :id="valueContainer">0%</div>
    <img
    class="halfcut-bg"
    src="@/assets/images/halfcut-bg.svg"
    alt="#"
    v-if="theme == 'light'"
  />
  <img
    class="halfcut-bg"
    src="@/assets/images/halfcut-bg.svg"
    alt="#"
    v-if="theme == 'medium'"
  />
  <img
    class="halfcut-bg"
    src="@/assets/images/halfcut-bg-dark.svg"
    alt="#"
    v-if="theme == 'dark'"
  />
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "HalfcutProgressLite",
  props: ['baseContainer','valueContainer','color','data'],
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    }
  },
  methods: {
    renderChart: function() {
      let progressBar = document.querySelector(`#${this.baseContainer}`);
      let valueContainer = document.querySelector(`#${this.valueContainer}`);

      let progressValue = 0;
      let progressEndValue = this.data;
      let speed = 10;

      let progress = setInterval(() => {
        if (progressValue >= progressEndValue) {
          clearInterval(progress);
          return;
        }
        progressValue = progressValue + 1;
        valueContainer.textContent = `${progressValue}%`;
        progressBar.style.background = `conic-gradient(
            ${this.color} ${progressValue * 3.6}deg,
            #7491AC ${progressValue * 3.6}deg
        )`;
      }, speed);  
    }
  },
  updated: function() {
    this.renderChart();
  },
  mounted: function () {
    this.renderChart();
  },
};
</script>

<style lang="scss" scoped>
*,
*:before,
*:after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.theme-dark.ar,.theme-dark.en {
  .cir-progress {
  position: relative;
  height: 110px;
  width: 110px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  .halfcut-bg {
      position: absolute;
      top: 14px;
      z-index: 0;
    }
}
.circular-progress:before {
  content: "";
  position: absolute;
  height: 84%;
  width: 84%;
  background-color: #ffffff;
  border-radius: 50%;
}
.value-container {
  position: relative;
  font-family: "Poppins", sans-serif;
  font-size: 20px;
  color: #fff;
  position: absolute;
  z-index: 10;
}
}
.theme-medium.ar,.theme-light.ar, .theme-medium.en, .theme-light.en {
  .cir-progress {
  position: relative;
  height: 110px;
  width: 110px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  .halfcut-bg {
      position: absolute;
      top: 14px;
      z-index: 0;
    }
}
.circular-progress:before {
  content: "";
  position: absolute;
  height: 84%;
  width: 84%;
  background-color: #ffffff;
  border-radius: 50%;
}
.value-container {
  position: relative;
  font-family: "Poppins", sans-serif;
  font-size: 20px;
  color: #000;
  position: absolute;
  z-index: 10;
}
}

</style>